import React from 'react';
import { Container, RegularText } from 'src/components';
import { Slider, Box } from '@mui/material';

interface Props {
  label: string;
  value: number | number[] | undefined;
  onChange: ((event: Event, value: number | number[], activeThumb: number) => void) | undefined;
  renderBody: any;
  min: number;
  max: number;
  step: number;
}

export const RangeSlider = ({ label, onChange, value, renderBody, max, min, step }: Props) => {
  return (
    <Container>
      <RegularText fontWeight="500" textLang={label} />
      <Box sx={{ width: '100%' }}>
        <Slider valueLabelDisplay="off" min={min} max={max} step={step} value={value} onChange={onChange} />
      </Box>
      {renderBody(value)}
    </Container>
  );
};
